import { useIntl } from "react-intl";

const IPAllowlisting = () => {
    const intl = useIntl();

    const messages = {
        title: intl.formatMessage({
            id: "ConfluencePricingPage.modal-content.ip-allowlisting.title",
            defaultMessage: "IP allowlisting"
        }),
        body: intl.formatMessage({
            id: "ConfluencePricingPage.modal-content.ip-allowlisting.body",
            defaultMessage:
                "Bolster your team’s security by limiting your site access to trusted IP ranges."
        }),
        altText: intl.formatMessage({
            id: "ConfluencePricingPage.modal-content.ip-allowlisting.alt-text",
            defaultMessage: "Example of IP allowlisting"
        }),
        imgCaption: intl.formatMessage({
            id: "ConfluencePricingPage.modal-content.ip-allowlisting.img-caption",
            defaultMessage:
                "Here’s what adding an IP address to the allowlist looks like in Confluence."
        })
    };

    return (
        <div>
            <h2>{messages.title}</h2>
            <p>{messages.body}</p>
            <img
                src="https://wac-cdn.atlassian.com/misc-assets/webp-images/IP_allowlist.1353.webp"
                alt={messages.altText}
                height={250}
                loading="lazy"
            />
            <p>{messages.imgCaption}</p>
        </div>
    );
};

export default IPAllowlisting;
